import * as React from "react";

import CardMedia from "@mui/material/CardMedia";
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";
import Carousel from "react-material-ui-carousel";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/system";

import { IMAGE_WIDTH } from "../common/sudCard";

const SudPictures = ({ imageUrls }) => {
  return (
    <>
      {imageUrls && imageUrls.length > 0 ? (
        <Carousel
          sx={{
            height: IMAGE_WIDTH,
            width: IMAGE_WIDTH,
          }}
          navButtonsAlwaysInvisible={imageUrls.length === 1}
          navButtonsAlwaysVisible={imageUrls.length !== 1}
        >
          {imageUrls.map((url, index) => (
            <CardMedia
              key={index}
              component="img"
              image={url}
              classes={{ img: { objectFit: "contain" } }}
              alt="Image of SuDs"
              height={IMAGE_WIDTH}
              width={IMAGE_WIDTH}
              sx={{
                objectFit: "contain",
              }}
            />
          ))}
        </Carousel>
      ) : (
        <Box
          width={IMAGE_WIDTH}
          height={IMAGE_WIDTH}
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <ImageNotSupportedIcon
            sx={{ width: IMAGE_WIDTH - 50, height: IMAGE_WIDTH - 50 }}
          />
          <Typography variant="caption">No image provided</Typography>
        </Box>
      )}
    </>
  );
};

export default SudPictures;
